(function ($){
    // $('.portfolio-listing__list a').on('click', function(e) {
    //     e.preventDefault();
    //
    //     let that = $(this),
    //         portfolio_card = that.parents('.portfolio-card '),
    //         portfolio_id = portfolio_card.attr('data-portfolio-id'),
    //         portfolio_modal = $('#portfolio-modal'),
    //         loader = portfolio_modal.find('.loader'),
    //         portfolio_modal_content = portfolio_modal.find('.modal-content');
    //
    //     // clean modal content
    //     portfolio_modal_content.html('');
    //
    //     // show modal
    //     portfolio_modal.modal('show');
    //
    //     let data = {
    //         action: 'theme_ajax_action',
    //         portfolio_id: portfolio_id
    //     };
    //
    //     $.ajax({
    //         type: "post",
    //         dataType: "html",
    //         url: custom_ajax.url,
    //         data: data,
    //         cache: false,
    //         beforeSend: function() {
    //             // loader.addClass('loading');
    //         },
    //         success: function(response) {
    //             portfolio_modal_content.html(response);
    //             // loader.removeClass('loading');
    //         },
    //         error: function(jqXHR, textStatus, errorThrown) {
    //             console.error('Error when trying to load portfolio card:', textStatus, errorThrown);
    //         }
    //     });
    // });
})(jQuery);
